import React__default from 'react';
import { Space, Icon } from '@sravni/react-design-system';
import modules_4bba97ad from './how-we-work-icon.module.scss.js';

const HowWeWorkIcon = ({ text, icon, key }) => (React__default.createElement(Space, { direction: "horizontal", align: "center", size: 12, key: `info-item-${key}` },
    React__default.createElement(Icon, { size: 16, shape: "round", background: "dark", color: "dark", className: modules_4bba97ad.icon }, icon),
    React__default.createElement("div", null, text)));

export { HowWeWorkIcon };
//# sourceMappingURL=index.js.map
